import { Dialog, DialogContent, DialogTitle, ListItem, ListItemText } from '@mui/material';
import humanFormat from 'human-format';

import CustomList from '../../../Lib/UI/Components/CustomList';
import { formatLocaleDateTimeString } from '../../../Lib/Utils/dateFormat';
import { ITileCacheSeedOperation } from '../../MapComponents/TileCache/types';
import { formatUtils } from '../formatUtils';


interface DownloadListItemStatusInfoPopupProps {
    op: ITileCacheSeedOperation;
    isOpen: boolean,
    onClose: () => void;
}

const DownloadListItemStatusInfoPopup = (props: DownloadListItemStatusInfoPopupProps): JSX.Element => {

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
        >
            <DialogTitle>Download Information</DialogTitle>
            <DialogContent>
                
                <CustomList>
                    <ListItem>
                        <ListItemText primary="Status" secondary={formatUtils.formatOperationStatus(props.op.status)} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Started" secondary={formatLocaleDateTimeString(props.op.startedAt)} />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Number of Tiles" secondary={props.op.numTotal} />
                    </ListItem>
                {!!props.op.downloadedBytes && 
                    <ListItem>
                        <ListItemText primary="Downloaded" secondary={humanFormat.bytes(props.op.downloadedBytes)} />
                    </ListItem>
                }
                {!!props.op.error && 
                    <ListItem>
                        <ListItemText primary="Error" secondary={props.op.error.message} />
                    </ListItem>
                }
                </CustomList>

            </DialogContent>
        </Dialog>
    );

};

export default DownloadListItemStatusInfoPopup;